// PaywallHairStyle - based on PaywallHair
import React, { useState, useRef, useEffect } from "react";
import { container } from "./../../constants/styles";
import welcomeImg from "./../../assets/images/hairstyle_main_paywall6.png";
import bodytypeTopCompareImg from "./../../assets/images/bodytype_top_compare.png";
import weddingGuestHeroImg from "./../../assets/images/wedding_guest_color_sample.png";
import readyImg from "./../../assets/images/ready.png";
import buttonImg from "./../../assets/images/button.png";
import stopImg from "./../../assets/images/stop_wasting.png";
import beforeImg from "./../../assets/images/style_beforeafter.jpeg";
import bodytypeBeforeImg from "./../../assets/images/bodytype_beforeafter.png";
import bodytypeBonusOfferImg from "./../../assets/images/bodytype_bonus_offer.png";
import bodytypeGallery1Img from "./../../assets/images/bodytype_gallery_1.png";
import bodytypeGallery2Img from "./../../assets/images/bodytype_gallery_2.png";
import bodytypeGallery3Img from "./../../assets/images/bodytype_gallery_3.png";
import weddingGuestResults1Img from "./../../assets/images/wedding_guest_results_1.png";
import weddingGuestResults2Img from "./../../assets/images/wedding_guest_results_2.png";
import weddingGuestResults3Img from "./../../assets/images/wedding_guest_results_3.png";

import freeGiftImg from "./../../assets/images/free_gift.png";
import analyzetImg from "./../../assets/images/new_Ania.png";
import toolsImg from "./../../assets/images/tools.png";
import seeImg from "./../../assets/images/see.png";
import resultImg from "./../../assets/images/result.png";
import mediaImg from "./../../assets/images/media.png";
import bloggersImg from "./../../assets/images/my-stylist-bloggers.png";
import visaImg from "./../../assets/images/my-stylist-guarantee.png";
import payIcon1 from "./../../assets/images/icons_payment/ic1.svg";
import payIcon2 from "./../../assets/images/icons_payment/ic2.svg";
import payIcon3 from "./../../assets/images/icons_payment/ic3.svg";
import payIcon4 from "./../../assets/images/icons_payment/ic4.svg";
import payIcon5 from "./../../assets/images/icons_payment/ic5.svg";
import payIcon6 from "./../../assets/images/icons_payment/ic6.svg";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Form from "../../components/Form/Form";
import { useSelector } from "react-redux";
import Button from "../../components/Button/Button";
import Popup from "../../components/Popup/Popup";
import AppleGooglePayButton from "../../components/AppleGooglePayButton/AppleGooglePayButton";
import { getPaywallPricingContext, isCanonicalPaywallRoute } from "../../utils/paywallPricing";
import { isOrganicOrSeoTraffic } from "../../utils/utm";
import { navigateToPostPaymentUpsell } from "../../utils/postPaymentUpsell";
import NotificationCarouselHairStyle from "../../components/NotificationCarousel/NotificationCarouselHairStyle";
import { useScrollToRef } from "../../hooks/useScrollToRef";
import {
  STRIPE_PRICE_ID,
  STRIPE_PUBLIC_KEY,
} from "../../constants/formConstants";
import discountImg from "./../../assets/images/common/discount.svg";
import { useTimer } from "../../hooks/useTimer";
import { useIsInViewport } from "../../hooks/useIsInViewPort";
import cosmoImg from "./../../assets/images/cosmo.png";
import vogueImg from "./../../assets/images/vogue.png";
import marieclaireImg from "./../../assets/images/marieclaire.png";
import elleImg from "./../../assets/images/elle.png";
import { useClientReferenceCookie } from "../../hooks/useClientReferenceCookie";
import { useNavigate } from "react-router-dom";
import { BadgeCheck, ShieldCheck } from "lucide-react";
import SubscriptionDisclaimer from "./SubscriptionDisclaimer";
import UserPhotoHeroShowcase from "./UserPhotoHeroShowcase";

const PAYMENT_METHOD_ICONS = [
  { src: payIcon1, alt: "Payment method" },
  { src: payIcon2, alt: "Payment method" },
  { src: payIcon3, alt: "Payment method" },
  { src: payIcon4, alt: "Payment method" },
  { src: payIcon5, alt: "Payment method" },
  { src: payIcon6, alt: "Payment method" },
];

const USER_PHOTO_TEASERS = [
  { label: "Best cut", score: "97%" },
  { label: "Best length", score: "96%" },
  { label: "Best styling", score: "94%" },
];

const BODYTYPE_PAYWALL_PATHS = [
  "/bodytype-3month-29-woman",
  "/wedding-guest-3month-29-woman",
];
const HAIRSTYLE_BRAND_PAYWALL_PATHS = [
  "/hairstyle-3month-29-woman",
  "/hairstyle",
];
const BODYTYPE_BRAND_PAYWALL_PATHS = [
  "/bodytype-3month-29-woman",
];
const PAYWALL_COLOR_THEMES = {
  purple: {
    accentText: "text-[#7C3A8D]",
    accentBg: "bg-[#7C3A8D]",
    bodyText: "text-[#111827]",
    mutedText: "text-[#6B7280]",
    timerText: "text-[#374151]",
    cardClass:
      "max-w-[900px] w-full rounded-lg border-2 border-[#7C3A8D]/20 bg-gradient-to-br from-[#F8F6F0] to-white p-6 shadow-lg font-['Inter',system-ui,-apple-system,sans-serif]",
    cardDivider: "border-[#7C3A8D]/20",
    ctaButton:
      "bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-8 py-3 rounded-md font-bold text-base max-w-[350px] mb-4 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-colors duration-200",
    paymentButton:
      "w-full bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-6 py-4 rounded-md font-semibold text-base inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-colors duration-200",
    stickyButton:
      "w-full bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-6 py-3 rounded-lg font-bold text-base inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-all duration-300 shadow-lg transform animate-pulse-scale hover:animate-none hover:scale-105",
    topBar: "bg-gradient-to-r from-[#F8F6F0] to-white border-b border-[#7C3A8D]/20",
    timerBar: "bg-gradient-to-r from-[#F8F6F0] to-[#FFE6D1] border-b border-[#7C3A8D]/10",
    stickyBar: "bg-gradient-to-r from-[#F8F6F0] to-white border-t border-[#7C3A8D]/20",
    checkBg: "bg-[#FFE6D1]",
    promoCard: "bg-gradient-to-r from-[#7C3A8D]/10 to-[#FFB6B9]/10 rounded-lg p-2 mb-2 border border-[#7C3A8D]/20",
    promoIcon: "w-8 h-8 bg-[#7C3A8D] rounded-md flex items-center justify-center mr-3",
    priceMuted: "text-[#9CA3AF]",
    disclaimerText: "text-[#9CA3AF]",
    paymentIconCard: "rounded-md border border-[#E5E7EB] bg-white",
    secureBadge: "border border-[#9CAF88]/40 bg-[#9CAF88]/15",
    secureText: "text-[#2F4B3B]",
    guaranteeCard: "rounded-xl border-2 border-[#9CAF88]/50 bg-white/80",
    guaranteeOrb: "bg-[#9CAF88]/20",
    guaranteeLink: "text-[#111827] underline decoration-[#9CAF88] underline-offset-4 hover:text-[#2F4B3B]",
    lowerDivider: "bg-[#232323]",
    oldPromoBlock: "bg-[#CAEFF9]",
    slideInactive: "bg-[#D8BEE2]",
    fontBody: "font-['Inter',system-ui,-apple-system,sans-serif]",
    heroAccentTheme: "default",
  },
  brand: {
    accentText: "text-[#9A2E1A]",
    accentBg: "bg-[#9A2E1A]",
    bodyText: "text-[#2B2622]",
    mutedText: "text-[#6F665D]",
    timerText: "text-[#2B2622]",
    cardClass:
      "max-w-[900px] w-full rounded-[28px] border border-[#EAD9CD] bg-gradient-to-br from-[#FFFFFF] to-[#F6F1EB] p-6 shadow-[var(--funnel-cs-shadow-card)] font-[var(--funnel-cs-font-body)]",
    cardDivider: "border-[#9A2E1A]/20",
    ctaButton:
      "bg-[#9A2E1A] hover:bg-[#762514] text-[#FBF8F3] px-8 py-3 rounded-[14px] font-bold text-base max-w-[350px] mb-4 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#9A2E1A] focus:ring-offset-2 transition-colors duration-200",
    paymentButton:
      "w-full bg-[#9A2E1A] hover:bg-[#762514] text-[#FBF8F3] px-6 py-4 rounded-[14px] font-semibold text-base inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#9A2E1A] focus:ring-offset-2 transition-colors duration-200",
    stickyButton:
      "w-full bg-[#9A2E1A] hover:bg-[#762514] text-[#FBF8F3] px-6 py-3 rounded-[14px] font-bold text-base inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#9A2E1A] focus:ring-offset-2 transition-all duration-300 shadow-lg transform animate-pulse-scale hover:animate-none hover:scale-105",
    topBar: "bg-gradient-to-r from-[#F6F1EB] to-white border-b border-[#9A2E1A]/20",
    timerBar: "bg-gradient-to-r from-[#F6F1EB] to-[#F3E2DB] border-b border-[#9A2E1A]/10",
    stickyBar: "bg-gradient-to-r from-[#F6F1EB] to-white border-t border-[#9A2E1A]/20",
    checkBg: "bg-[#F3E2DB]",
    promoCard: "bg-[#F3E2DB] rounded-[18px] p-3 mb-3 border border-[#E5C9BD]",
    promoIcon: "w-8 h-8 bg-[#9A2E1A] rounded-[14px] flex items-center justify-center mr-3",
    priceMuted: "text-[#8A8075]",
    disclaimerText: "text-[#8A8075]",
    paymentIconCard: "rounded-[14px] border border-[#EAD9CD] bg-white",
    secureBadge: "border border-[#E5C9BD] bg-[#F3E2DB]",
    secureText: "text-[#7A3F22]",
    guaranteeCard: "rounded-[18px] border border-[#E5C9BD] bg-[#FBF8F3]",
    guaranteeOrb: "bg-[#F3E2DB]",
    guaranteeLink: "text-[#2B2622] underline decoration-[#9A2E1A] underline-offset-4 hover:text-[#9A2E1A]",
    lowerDivider: "bg-[#2B2622]",
    oldPromoBlock: "bg-[#F3E2DB]",
    slideInactive: "bg-[#E5C9BD]",
    fontBody: "font-[var(--funnel-cs-font-body)]",
    heroAccentTheme: "brand",
  },
};

function PaywallHairStyle({ useUserPhotoHero = false }) {
  const pricing = getPaywallPricingContext(window.location.pathname, window.location.search);
  const isOrganicDisclaimer =
    isCanonicalPaywallRoute(window.location.pathname) &&
    isOrganicOrSeoTraffic(window.location.search);
  const navigate = useNavigate();
  const pathname = window.location?.pathname || "";
  const isWeddingGuestPaywall = pathname === "/wedding-guest-3month-29-woman";
  const isBodytypePaywall = BODYTYPE_PAYWALL_PATHS.includes(pathname);
  const isHairstyleBrandPaywall = HAIRSTYLE_BRAND_PAYWALL_PATHS.includes(pathname);
  const isBodytypeBrandPaywall = BODYTYPE_BRAND_PAYWALL_PATHS.includes(pathname);
  const shouldUseBrandTheme = isHairstyleBrandPaywall || isBodytypeBrandPaywall;
  const colorTheme = shouldUseBrandTheme
    ? PAYWALL_COLOR_THEMES.brand
    : PAYWALL_COLOR_THEMES.purple;
  const shouldShowTopLogo = pathname !== "/hairstyle-3month-29-woman";
  const shouldUseUserPhotoHero = useUserPhotoHero && !isBodytypePaywall;
  const heroImageSrc = isWeddingGuestPaywall
    ? weddingGuestHeroImg
    : isBodytypePaywall
      ? bodytypeTopCompareImg
      : welcomeImg;
  const discountBlockRef = useRef(null);
  const heresWhatYouGetRef = useRef(null);
  const formattedTime = useTimer(10);

  const scrollToRef = useScrollToRef();
  const { elementRef: trustSectionRef, isInViewPort: isTrustSectionVisible, wasInViewPort: wasTrustSectionVisible } = useIsInViewport();
  
  const [showStickyButton, setShowStickyButton] = useState(false);
  const [currentGallerySlide, setCurrentGallerySlide] = useState(0);

  useClientReferenceCookie();

  // Set page title and meta description
  useEffect(() => {
    document.title = "Get Your Hair Style Analysis for only $1";
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = "Unlock your personalized hair style recommendations. Discover the best hairstyles and haircuts that flatter your face shape.";
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (heresWhatYouGetRef.current) {
        const rect = heresWhatYouGetRef.current.getBoundingClientRect();
        // Show button only when user has scrolled past the section start (section top is at or above viewport top)
        const isAtOrBelowSection = rect.top <= 0;
        setShowStickyButton(isAtOrBelowSection);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const bodytypeGalleryImages = [
    bodytypeGallery1Img,
    bodytypeGallery2Img,
    bodytypeGallery3Img,
  ];
  const weddingGuestGalleryImages = [
    weddingGuestResults1Img,
    weddingGuestResults2Img,
    weddingGuestResults3Img,
  ];
  const styleResultsGalleryImages = isWeddingGuestPaywall
    ? weddingGuestGalleryImages
    : bodytypeGalleryImages;

  useEffect(() => {
    if (!isBodytypePaywall) return undefined;

    const intervalId = window.setInterval(() => {
      setCurrentGallerySlide((prev) => (prev + 1) % styleResultsGalleryImages.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [isBodytypePaywall, styleResultsGalleryImages.length]);

  const landingPlans = [
    {
      value: pricing.trialCost,
      text: pricing.trialDisplay,
      trialValue: pricing.trialValue,
      trialValueText: pricing.trialValueText,
      willBeText:
        "Then your yearly Subscription Period will start and you will be charged $27.99 every quarter. No refunds if canceled before the end of Subscription Period.",
    },
    {
      value: "9.78",
      text: "$9.78",
      trialValue: 9.78,
      trialValueText: "$9.78",
      willBeText:
        "Then your yearly Subscription Period will start and you will be charged $27.99 every quarter. No refunds if canceled before the end of Subscription Period.",
    },
  ];

  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe(STRIPE_PUBLIC_KEY)
  );

  // V1 route always has $1 plan preselected
  const [plan, setPlan] = useState(pricing.trialCost);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [showPromoCode, setShowPromoCode] = useState(false);

  const heresWhatYouGetItems = isWeddingGuestPaywall
    ? [
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Wedding look breakdown</span>
              {" "}— based on your answers and style goals
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Best dress silhouettes</span>
              {" "}— shapes, lengths, necklines, and sleeve ideas for you
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Best colors for the wedding</span>
              {" "}— flattering shades for your coloring and event style
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Hair &amp; makeup direction</span>
              {" "}— hairstyle and makeup ideas that complete the look
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Complete outfit formulas</span>
              {" "}— dress + shoes + accessories + styling notes
            </>
          ),
        },
      ]
    : isBodytypePaywall
    ? [
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Your body type breakdown</span>
              {" "}— based on your answers
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Personal style archetype</span>
              {" "}— see which style direction fits you best
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Best silhouettes for your shape</span>
              {" "}— jeans, tops, dresses, and outfit lines
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Personal outfit formulas</span>
              {" "}— easy styling advice tailored to your body type and goals
            </>
          ),
        },
      ]
    : [
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Your best-match haircuts &amp; styles </span>
              <span className={`font-normal ${colorTheme.mutedText}`}>(based on your features)</span>
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>AI hairstyle try-on</span> — preview haircuts on your photo
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Try different lengths instantly</span> — short, medium, long
            </>
          ),
        },
        {
          richText: (
            <>
              <span className={`font-bold ${colorTheme.accentText}`}>Style feedback</span> — get guidance on every look
            </>
          ),
        },
      ];

  const trustSectionStats = isBodytypePaywall
    ? {
        completedCount: "348",
        completedLabel: "style analyses completed today",
        popularResult: "Soft Classic",
      }
    : {
        completedCount: "348",
        completedLabel: "tests taken today",
        popularResult: "Effortless Waves",
      };

  const trustSectionTitle = isBodytypePaywall
    ? "Why You Can Trust Your Results"
    : "Why You Can Trust Our Results";

  const trustItems = isBodytypePaywall
    ? [
        {
          title: "Personalized Body Type Analysis",
          description:
            "Your result is based on your body proportions, frame scale, style preferences, and outfit goals.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          ),
        },
        {
          title: "AI-Powered Style Matching",
          description:
            "We analyze your answers and photo, if uploaded, to match you with your body type, style essence, and best silhouettes.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          ),
        },
        {
          title: "Trusted by 355,000+ Users",
          description:
            "A global community has used our analysis to understand what suits them and build a more flattering personal style.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          ),
        },
      ]
    : [
        {
          title: "Proven Hairstyle Analysis System",
          description:
            "Our method is based on professional face-shape and hair-structure analysis, used by top hairstylists and image consultants worldwide.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          ),
        },
        {
          title: "AI-Powered Technology",
          description:
            "We use advanced computer vision and machine learning to analyze your features with 99% accuracy and eliminate bias.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          ),
        },
        {
          title: "Backed by 355,000+ Users",
          description:
            "Trusted by a global community who've used our analysis to upgrade their personal style with confidence.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          ),
        },
      ];

  const featuredInTitle = isBodytypePaywall
    ? "Style Analysis Has Been Featured In:"
    : "myStylist PRO Has Been Featured In:";

  const benefitsItems = isWeddingGuestPaywall
    ? [
        {
          text: "Understand what flatters your figure most",
          subtext:
            "Get personalized guidance on the dress shapes and proportions that work best for you.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
          ),
        },
        {
          text: "Look more balanced and elegant",
          subtext:
            "Find necklines, sleeve options, lengths, and styling details that enhance your shape.",
          icon: (
            <>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </>
          ),
        },
        {
          text: "Shop smarter for the occasion",
          subtext:
            "Know which dress colors, silhouettes, and details to look for before you buy.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          ),
        },
        {
          text: "Feel confident in your full wedding look",
          subtext:
            "Build an outfit with the right dress, accessories, hairstyle, and makeup direction.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          ),
        },
      ]
    : isBodytypePaywall
    ? [
        {
          text: "Understand what truly suits your body",
          subtext:
            "Get clear guidance based on your proportions, frame, and style goals.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
          ),
        },
        {
          text: "Look more balanced and put-together",
          subtext:
            "Discover silhouettes, lengths, and outfit formulas that flatter your shape.",
          icon: (
            <>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </>
          ),
        },
        {
          text: "Shop smarter and waste less money",
          subtext:
            "Know what to look for — and what to avoid — before buying.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          ),
        },
        {
          text: "Feel more confident in your style every day",
          subtext:
            "Build outfits that feel natural, flattering, and aligned with you.",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          ),
        },
      ]
    : [
        {
          text: "Look instantly more put-together with the right hairstyle",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
          ),
        },
        {
          text: "Enhance your personal brand and make lasting impressions",
          icon: (
            <>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </>
          ),
        },
        {
          text: "Choose haircuts smarter-know what truly suits you",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          ),
        },
        {
          text: "Feel more confident in your look every day",
          icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          ),
        },
      ];

  const benefitsBottomLine = isWeddingGuestPaywall
    ? "Take the guesswork out of dressing for weddings with a personalized guest style guide."
    : isBodytypePaywall
      ? "Transform how you dress and feel with personalized body type and style guidance."
      : "Transform how you look and feel with personalized hair guidance";

  const primaryCtaText = isWeddingGuestPaywall
    ? "Get My Style Guide"
    : isBodytypePaywall
      ? "Get My Personalized Style Guide"
      : "GET MY HAIRSTYLES NOW!";

  const isApplePayAvailible = useSelector(
    (state) => state.payment.isApplePayAvailible
  );

  const onGetClick = () => {
    if (heresWhatYouGetRef.current) {
      scrollToRef(heresWhatYouGetRef, 100);
      return;
    }
  };

  const onPlanClick = (plan) => {
    setPlan(plan.value);
  };

  const onClosePopupClick = () => {
    setPopupOpen(false);
  };

  const onPopupOpenClick = () => {
    setPopupOpen(true);
  };

  const onSuccess = (paymentIntentId) => {
    navigateToPostPaymentUpsell(navigate, "/getofferhair", paymentIntentId);
  };

  const renderFullForm = (onlyApplePay) => {
    return (
      <div className={`max-w-[450px] mx-auto`}>
        <Elements stripe={stripePromise}>
          <Form
            priceID={STRIPE_PRICE_ID}
            trialCost={plan}
            paymentAmount={pricing.amount}
            paymentCurrency={pricing.currency}
            paymentValue={pricing.purchaseValue}
            littleText={"little text"}
            title={""}
            onlyApplePay={onlyApplePay}
            successAction={onSuccess}
          />
        </Elements>
      </div>
    );
  };

  const renderPopupForm = () => {
    return (
      <div>
        <h3 className="text-[24px] font-[700] text-[rgb(0,46,56)] mb-2">
          Payment method
        </h3>
        <p className="text-[12px] text-[rgb(50,87,97)]">
          {" "}
          You will only be charged {pricing.trialDisplay}
        </p>
        {renderFullForm()}
      </div>
    );
  };

  const TimerRender = () => {
    return (
      <div className={`${colorTheme.timerBar} h-14 w-full flex items-center`}>
        <div className={`${colorTheme.fontBody} text-center w-full`}>
          <p className={`text-sm font-medium ${colorTheme.mutedText} leading-normal`}>
            Color Analysis results only <span className={`font-bold ${colorTheme.accentText}`}>{pricing.trialDisplay}!</span> Offer ends in:
          </p>
          <p className={`text-2xl font-extrabold ${colorTheme.accentText} leading-tight tracking-tight`}>
            {formattedTime}
          </p>
        </div>
      </div>
    );
  };

  const getSeasonalPromoCode = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;

    let season = "";

    if (month >= 3 && month <= 5) {
      season = "SPRING";
    } else if (month >= 6 && month <= 8) {
      season = "SUMMER";
    } else if (month >= 9 && month <= 11) {
      season = "FALL";
    } else {
      season = "WINTER";
    }

    return `${season}${year}`;
  };

  const discountBlockRender = () => {
    return (
      <div>
        <div className="mb-1 flex items-center justify-between">
          <p className="text-[18px] font-[800] text-[#0A364A]">
            Promo code applied
          </p>
          <div
            onClick={() => scrollToRef(discountBlockRef, 100)}
            className="flex cursor-pointer items-center rounded-[8px] bg-[#08A0C8] px-3 py-[10px] text-[18px] font-[800] text-[#ffffff]"
          >
            <img src={discountImg} className="mr-1 min-w-5" alt="discount" />
            <p>{getSeasonalPromoCode()}</p>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-[16px] font-[500] text-[#0A364A]">
            Promo code reserved for:
          </p>
          <p className="text-[16px] font-[500] text-[#0A364A]">
            {formattedTime}
          </p>
        </div>
      </div>
    );
  };

  const trustSectionContent = (
    <div ref={trustSectionRef} className="flex justify-center mb-8 px-2">
      <div className={colorTheme.cardClass}>
        <div className={`mb-6 pb-4 border-b ${colorTheme.cardDivider}`}>
          <div className="text-left">
            <p className={`text-lg font-medium ${colorTheme.bodyText} mb-1`}>
              Over <span className={`font-bold ${colorTheme.accentText}`}>{trustSectionStats.completedCount}</span> {trustSectionStats.completedLabel}
            </p>
            <p className={`text-base ${colorTheme.bodyText}`}>
              Most popular result today: <span className={`font-semibold ${colorTheme.accentText}`}>{trustSectionStats.popularResult}</span>
            </p>
          </div>
        </div>

        <div className="mb-6">
          <h2 className={`text-2xl font-bold ${colorTheme.bodyText} mb-6 text-left tracking-wide ${colorTheme.fontBody}`}>
            {isBodytypePaywall ? (
              trustSectionTitle
            ) : (
              <>
                Why <span className={colorTheme.accentText}>You Can Trust</span> Our Results
              </>
            )}
          </h2>

          <div className="space-y-4">
            {trustItems.map((item, index) => (
              <div className="flex items-start space-x-4" key={index}>
                <div className={`w-12 h-12 ${colorTheme.checkBg} rounded-lg flex items-center justify-center flex-shrink-0`}>
                  <svg className={`w-6 h-6 ${colorTheme.accentText}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {item.icon}
                  </svg>
                </div>
                <div className="text-left">
                  <h4 className={`font-bold ${colorTheme.bodyText} mb-1 text-left ${colorTheme.fontBody}`}>{item.title}</h4>
                  <p className={`text-sm ${colorTheme.mutedText} leading-relaxed text-left ${colorTheme.fontBody}`}>
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={`text-left pt-6 border-t ${colorTheme.cardDivider}`}>
          <h3 className={`text-xl font-bold ${colorTheme.bodyText} mb-4 text-left tracking-wide ${colorTheme.fontBody}`}>
            {isBodytypePaywall ? (
              featuredInTitle
            ) : (
              <>
                <span className={colorTheme.accentText}>myStylist PRO</span> Has Been Featured In:
              </>
            )}
          </h3>
          <div className="flex items-center justify-start space-x-4 opacity-60">
            <img src={cosmoImg} alt="Cosmopolitan" className="h-8 grayscale" />
            <img src={vogueImg} alt="Vogue" className="h-4 grayscale" />
            <img src={marieclaireImg} alt="Marie Claire" className="h-16 grayscale" />
            <img src={elleImg} alt="Elle" className="h-8 grayscale" />
          </div>
        </div>
      </div>
    </div>
  );

  const bonusSectionContent = (
    <>
      <div className="flex justify-center mb-8 px-4">
        <div className={`max-w-[500px] text-center ${colorTheme.fontBody}`}>
          {isBodytypePaywall ? (
            <>
              <h2 className={`text-2xl md:text-3xl font-bold ${colorTheme.bodyText} mb-4 leading-tight`}>
                Bonus Included Today
              </h2>
              <p className={`text-lg ${colorTheme.mutedText} leading-relaxed`}>
                Free Color Analysis &amp; Hair Match with your body type results.
              </p>
            </>
          ) : (
            <>
              <h2 className={`text-2xl md:text-3xl font-bold ${colorTheme.bodyText} mb-4 leading-tight`}>
                Stop Wasting Precious Time
              </h2>
              <p className={`text-lg ${colorTheme.mutedText} leading-relaxed`}>
                Discover your personalized hair blueprint and start feeling fresh, polished, and confident every day.
              </p>
            </>
          )}
        </div>
      </div>

      <div className="flex justify-center mb-4">
        <img
          src={isBodytypePaywall ? bodytypeBonusOfferImg : beforeImg}
          alt="before"
          className="max-w-full w-[500px]"
        />
      </div>

      <div className="flex justify-center mb-4">
        <Button
          buttonStyles={colorTheme.ctaButton}
          text={primaryCtaText}
          blick={false}
          action={() => onGetClick()}
        />
      </div>
    </>
  );

      return (
      <div>
      {/* Sticky wrapper for notification and timer sections */}
      <div className="sticky top-0 z-50">
        {/* Top notification banner */}
        <div className={`w-full ${colorTheme.topBar} cursor-pointer`} onClick={onGetClick}>
          <NotificationCarouselHairStyle
            accentTheme={shouldUseBrandTheme ? "brand" : "default"}
            isBodytype={isBodytypePaywall}
          />
        </div>
        
        {/* Timer section */}
        <div className={`w-full ${colorTheme.timerBar} cursor-pointer`} onClick={onGetClick}>
          <div className={`py-2 ${colorTheme.fontBody} text-center`}>
            <p className={`text-sm font-medium ${colorTheme.timerText} leading-normal`}>
              {isBodytypePaywall ? "Body Type results only " : "Hair Style results only "}
              <span className={`font-bold ${colorTheme.accentText}`}>{pricing.trialDisplay}!</span> Offer ends in:
            </p>
            <p className={`text-lg font-extrabold ${colorTheme.accentText} leading-tight tracking-tight`}>
              {formattedTime}
            </p>
          </div>
        </div>
      </div>
      
      <div className={`${container} pt-3 pb-6`}>

      {shouldShowTopLogo ? (
        <div className="flex justify-center mb-2">
          <span className={`text-sm font-semibold tracking-normal ${colorTheme.bodyText}`}>
            My Stylist
          </span>
        </div>
      ) : null}

      <div className="flex justify-center mb-2">
        <div className={`text-center max-w-[500px] ${colorTheme.fontBody}`}>
          {isBodytypePaywall ? (
            <h2 className={`text-2xl sm:text-3xl md:text-4xl font-bold ${colorTheme.bodyText} leading-tight tracking-tight mb-1`}>
              {isWeddingGuestPaywall ? (
                <>Your Wedding Guest Look Is Ready</>
              ) : (
                <>
                  Your Body Type <span className={colorTheme.accentText}>Results Are Ready</span>
                </>
              )}
            </h2>
          ) : (
            <>
              <h2 className={`text-2xl sm:text-3xl md:text-4xl font-bold ${colorTheme.bodyText} leading-tight tracking-tight mb-0.5`}>
                Your Best Hairstyles &
              </h2>
              <div className="flex items-center justify-center mb-1">
                <h2 className={`text-2xl sm:text-3xl md:text-4xl font-bold ${colorTheme.accentText} leading-tight tracking-tight`}>
                  Hair Colors are ready
                </h2>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="flex justify-center mb-3 px-2">
        {shouldUseUserPhotoHero ? (
          <UserPhotoHeroShowcase
            accentTheme={colorTheme.heroAccentTheme}
            fallbackSrc={welcomeImg}
            teasers={USER_PHOTO_TEASERS}
          />
        ) : (
          <img
            src={heroImageSrc}
            alt={isWeddingGuestPaywall ? "Wedding guest look preview" : "welcome"}
            className="max-w-full w-full rounded-lg"
          />
        )}
      </div>

      <div className="flex justify-center mb-3">
        <Button
          buttonStyles={colorTheme.ctaButton}
          text={primaryCtaText}
          blick={false}
          action={() => onGetClick()}
        />
      </div>

      <div className="flex justify-center mb-8 px-2">
        <div ref={heresWhatYouGetRef} className={colorTheme.cardClass}>
          <h2 className="text-lg sm:text-xl font-bold text-center mb-6">
            <span className={colorTheme.bodyText}>Here's What </span>
            <span className={colorTheme.accentText}>You Get</span>
          </h2>
          
          <div className="space-y-2 mb-3">
            {heresWhatYouGetItems.map((item, index) => (
              <div className="flex items-start" key={index}>
                <div className={`flex-shrink-0 w-5 h-5 ${colorTheme.checkBg} rounded-sm flex items-center justify-center mr-3 mt-0.5`}>
                  <span className={`${colorTheme.accentText} text-xs font-bold`}>✓</span>
                </div>
                <p className={`text-base ${colorTheme.mutedText} leading-relaxed text-left`}>
                  {item.richText}
                </p>
              </div>
            ))}
          </div>

          {/* Promo Code Section */}
          <div className={colorTheme.promoCard}>
            <div className="flex items-center mb-2">
              <div className={colorTheme.promoIcon}>
                <span className="text-white text-lg">🎁</span>
              </div>
              <div>
                <p className={`font-bold ${colorTheme.accentText} text-sm`}>Promo Code Season26 Applied</p>
                <p className={`text-sm ${colorTheme.mutedText} text-left`}>You save 85%</p>
              </div>
            </div>
          </div>

          {/* Pricing Section */}
          <div className={`flex justify-between items-center mb-3 pb-4 border-b ${colorTheme.cardDivider}`}>
            <span className={`text-sm font-semibold ${colorTheme.bodyText}`}>Total due today:</span>
            <div className="text-right">
              <span className={`text-sm ${colorTheme.priceMuted} line-through mr-2`}>{pricing.trialOriginalDisplay}</span>
              <span className={`text-lg font-bold ${colorTheme.accentText}`}>{pricing.trialDisplay}</span>
            </div>
          </div>

          <p className={`mb-3 text-center text-sm font-medium ${colorTheme.mutedText}`}>
            30-day money back guarantee
          </p>

          {/* Payment Buttons */}
          <div className="space-y-1 mb-6">
            {/* Apple Pay and Google Pay */}
            <Elements stripe={stripePromise}>
              <AppleGooglePayButton
                trialCost={plan}
            paymentAmount={pricing.amount}
            paymentCurrency={pricing.currency}
            paymentValue={pricing.purchaseValue}
                onSuccess={onSuccess}
                isDisabled={false}
              />
            </Elements>
            
            {/* Credit/Debit Card Button */}
            <Button
              buttonStyles={colorTheme.paymentButton}
              text="💳 Credit or Debit Card"
              isButtonDisabled={false}
              action={() => onPopupOpenClick()}
            />
          </div>

          {/* Terms Text */}
          <SubscriptionDisclaimer
            price={pricing.subscriptionDisclaimerPrice}
            className={`${colorTheme.disclaimerText} text-xs leading-relaxed text-left`}
            isOrganicOrSeo={isOrganicDisclaimer}
            billingPeriod="every 3 months"
          />

          {/* PaySafe + Payment Methods + Guarantee */}
          <div className="mt-5">
            <div className="flex flex-col items-center gap-3">
              <div className={`inline-flex items-center gap-2 rounded-full ${colorTheme.secureBadge} px-4 py-2 ${colorTheme.fontBody}`}>
                <ShieldCheck className={`h-5 w-5 ${colorTheme.secureText}`} aria-hidden="true" />
                <span className={`text-sm font-semibold ${colorTheme.secureText}`}>
                  Pay Safe &amp; Secure
                </span>
              </div>

              <div className="flex items-center justify-center gap-2 flex-wrap">
                {PAYMENT_METHOD_ICONS.map((icon, idx) => (
                  <div
                    key={`${icon.src}-${idx}`}
                    className={`flex h-9 w-14 items-center justify-center ${colorTheme.paymentIconCard} shadow-sm`}
                  >
                    <img
                      src={icon.src}
                      alt={icon.alt}
                      className="h-5 w-auto max-w-[44px]"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className={`mt-4 relative overflow-hidden ${colorTheme.guaranteeCard} p-5 shadow-sm`}>
              <div className={`mx-auto max-w-[520px] text-center ${colorTheme.fontBody}`}>
                <h3 className={`text-xl font-extrabold ${colorTheme.bodyText}`}>
                  30-day money-back guarantee
                </h3>
                <p className={`mt-2 text-base ${colorTheme.mutedText} leading-relaxed`}>
                  If you reach out within 30 days of purchase, we'll give you a
                  full refund.
                </p>
                <a
                  href="https://my-stylist.pro/terms#refund"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`mt-3 inline-block text-base font-semibold ${colorTheme.guaranteeLink}`}
                >
                  Learn more
                </a>
              </div>

              <div className={`pointer-events-none absolute -right-6 -bottom-6 h-20 w-20 rounded-full ${colorTheme.guaranteeOrb} flex items-center justify-center`}>
                <BadgeCheck className={`h-10 w-10 ${colorTheme.accentText}`} aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {isBodytypePaywall ? bonusSectionContent : trustSectionContent}
      {isBodytypePaywall ? trustSectionContent : bonusSectionContent}




      <div className="flex justify-center mb-4 -mx-4">
        {isBodytypePaywall ? (
          <div className="w-full px-4">
            <h2 className={`mb-4 text-center text-2xl md:text-3xl font-bold ${colorTheme.bodyText} leading-tight ${colorTheme.fontBody}`}>
              Real Style Results From Women Like You
            </h2>
            <div className="relative mx-auto max-w-[720px] overflow-hidden rounded-[24px] bg-white shadow-lg">
              <div
                className="flex transition-transform duration-500 ease-out"
                style={{ transform: `translateX(-${currentGallerySlide * 100}%)` }}
              >
                {styleResultsGalleryImages.map((image, index) => (
                  <div className="w-full flex-shrink-0" key={index}>
                    <img
                      src={image}
                      alt={`style result ${index + 1}`}
                      className="w-full"
                    />
                  </div>
                ))}
              </div>

              <button
                type="button"
                aria-label="Previous slide"
                className={`absolute left-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 ${colorTheme.accentText} shadow-md transition hover:bg-white`}
                onClick={() =>
                  setCurrentGallerySlide((prev) =>
                    prev === 0 ? styleResultsGalleryImages.length - 1 : prev - 1
                  )
                }
              >
                &#8249;
              </button>
              <button
                type="button"
                aria-label="Next slide"
                className={`absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 ${colorTheme.accentText} shadow-md transition hover:bg-white`}
                onClick={() =>
                  setCurrentGallerySlide((prev) => (prev + 1) % styleResultsGalleryImages.length)
                }
              >
                &#8250;
              </button>

              <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 gap-2 rounded-full bg-white/85 px-3 py-2 shadow-sm">
                {styleResultsGalleryImages.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    aria-label={`Go to slide ${index + 1}`}
                    className={`h-2.5 w-2.5 rounded-full transition ${
                      index === currentGallerySlide ? colorTheme.accentBg : colorTheme.slideInactive
                    }`}
                    onClick={() => setCurrentGallerySlide(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <img src={analyzetImg} alt="analyzet" className="max-w-full w-full" />
        )}
      </div>

      <div className="flex justify-center mb-8 px-4">
        <div className={`max-w-[500px] text-center ${colorTheme.fontBody}`}>
          <h2 className={`text-2xl md:text-3xl font-bold ${colorTheme.bodyText} mb-6 leading-tight`}>
            How You'll Benefit
          </h2>
          
          <div className="grid grid-cols-2 gap-6 mb-6">
            {benefitsItems.map((item, index) => (
              <div className="flex flex-col items-center" key={index}>
                <div className={`w-16 h-16 ${colorTheme.checkBg} rounded-lg flex items-center justify-center mb-3`}>
                  <svg className={`w-8 h-8 ${colorTheme.accentText}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {item.icon}
                  </svg>
                </div>
                <p className={`text-sm ${colorTheme.bodyText} text-center leading-relaxed`}>
                  {item.text}
                </p>
                {item.subtext ? (
                  <p className={`text-sm ${colorTheme.bodyText} text-center leading-relaxed mt-2`}>
                    {item.subtext}
                  </p>
                ) : null}
              </div>
            ))}
          </div>
          
          <p className={`text-base ${colorTheme.bodyText} leading-relaxed`}>
            {isBodytypePaywall ? (
              <>
                <span className="font-bold">Bottom line:</span>
                <br />
                <br />
                {benefitsBottomLine}
              </>
            ) : (
              benefitsBottomLine
            )}
          </p>
        </div>
      </div>

      <div className={`h-[2px] w-full mb-4 ${colorTheme.lowerDivider}`}></div>

      <div className="flex justify-center mb-4 ">
        <img src={bloggersImg} alt="blog" className="max-w-full w-[500px]" />
      </div>

      <div className="flex justify-center mb-4">
        <Button
          buttonStyles={colorTheme.ctaButton}
          text={primaryCtaText}
          blick={false}
          action={() => onGetClick()}
        />
      </div>

      {showPromoCode && (
        <div className={`my-4 rounded-[8px] ${colorTheme.oldPromoBlock} px-5 py-4`}>
          {discountBlockRender()}
        </div>
      )}

      {false && (
      <div>
        <div
          ref={discountBlockRef}
          className={
            "rounded-[8px] border-[2px] border-[#DBE6E2] px-4 pb-[22px] pt-8"
          }
        >
          <p className={"mb-6 text-[16px] leading-5 text-[#0A364A] text-left"}>
            We've helped thousands of women discover their style and glow with
            confidence, and now we want to help you too 🔥
          </p>
          <p
            className={
              "mb-6 text-[16px] font-[900] leading-5 text-[#0A364A] text-left"
            }
          >
            We believe money shouldn't be a barrier to feeling fabulous and
            finally solving wardrobe challenges once and for all. So, choose the
            amount you think is reasonable to try us for 1 week ❤️❤️❤️
          </p>

          <p
            className={
              "mb-6 text-[16px] font-[900] leading-5 text-[#BD4192] text-left"
            }
          >
            It costs us $9.78 to cover our expenses for the trial, but we want
            you to pick a price that you're comfortable with.
          </p>

          <div
            className={
              "mb-1 mr-3 flex justify-end text-[14px] leading-5 text-[#6894A8]"
            }
          >
            most popular choice*
          </div>

          <div className={"mb-6 flex justify-between"}>
            {landingPlans.map((item, index) => {
              return (
                <div
                  onClick={() => {
                    onPlanClick(item);
                  }}
                  className={`w-[48%] rounded-[8px] border border-[#DBE6E2] bg-[#F5F7F8] py-4 transition duration-300 ${
                    plan === item.value ? "!border-[#08A0C8] !bg-[#E0EEF1]" : ""
                  }`}
                  key={`${index}-plan`}
                >
                  <p
                    className={
                      "text-center text-[16px] font-[900] leading-[22px]"
                    }
                  >
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="mb-6">
            <Elements stripe={stripePromise}>
              <AppleGooglePayButton
                trialCost={plan}
            paymentAmount={pricing.amount}
            paymentCurrency={pricing.currency}
            paymentValue={pricing.purchaseValue}
                onSuccess={onSuccess}
                isDisabled={!plan}
              />
            </Elements>
          </div>

          {isApplePayAvailible === false ? (
            <div>
              <Button
                buttonStyles={
                  "bg-[#7C3A8D] hover:bg-[#A259B5] text-white px-8 py-3 rounded-md font-bold text-base mb-4 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-[#7C3A8D] focus:ring-offset-2 transition-colors duration-200"
                }
                text={primaryCtaText}
                isButtonDisabled={!plan}
                action={() => onPopupOpenClick()}
              />
              <p
                className={
                  "text-center text-[16px] leading-[22px] text-[#3E636C]"
                }
              >
                *7-day trial
              </p>

              <SubscriptionDisclaimer
                price={pricing.subscriptionDisclaimerPrice}
                className="text-[rgb(165,165,165)] text-[12px] leading-[14px] text-left mt-2"
                isOrganicOrSeo={isOrganicDisclaimer}
                billingPeriod="every 3 months"
                showPrivacyLink={false}
              />
            </div>
          ) : (
            <div
              className={`relative ${
                plan === null ? "h-0 max-h-0" : "h-[auto] !max-h-[750px]"
              } transiton overflow-hidden duration-300`}
            >
              <div className={`relative`}>
                <div>{renderFullForm(true)}</div>
              </div>

              <div>
                <p
                  onClick={() => setPopupOpen(true)}
                  className="cursor-pointer text-center text-[16px] font-[500] text-[#0A364A] underline"
                >
                  Continue with other payment options
                </p>
              </div>

              <SubscriptionDisclaimer
                price={pricing.subscriptionDisclaimerPrice}
                className="text-[rgb(165,165,165)] text-[12px] leading-[14px] text-left mt-2"
                isOrganicOrSeo={isOrganicDisclaimer}
                billingPeriod="every 3 months"
                showPrivacyLink={false}
              />
            </div>
          )}
        </div>
      </div>
      )}

      <div className="flex justify-center mb-10 ">
        <img src={visaImg} alt="visa" className="max-w-full w-[500px]" />
      </div>

      {isPopupOpen ? (
        <Popup
          content={<div className="pt-4">{renderPopupForm()}</div>}
          isOpen={isPopupOpen}
          closeFunction={() => onClosePopupClick()}
        />
      ) : null}

      {/* Sticky Bottom Button */}
      {showStickyButton && (
        <div className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-500 ${showStickyButton ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
          <div className={`w-full ${colorTheme.stickyBar} px-4 py-4 shadow-lg`}>
            <div className="max-w-sm mx-auto">
              <Button
                buttonStyles={colorTheme.stickyButton}
                text={primaryCtaText}
                blick={false}
                action={() => onGetClick()}
              />
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default PaywallHairStyle;
